const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/admin/system/settings/custom_texts.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
export const Route = createFileRoute("/_authenticated/_feature_announcement/admin/system/settings/custom_texts")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Custom Labels Settings",
      description: "Page title"
    })
  }
});